/**
 * check notification store to popup toast
 * @2025/10/10
 */
import { useEffect } from 'react';
import toast from 'react-hot-toast';

import { useNotificationStore, Notification } from '@/stores/notifications';

/**
 * show notification with toast
 */
export const useNotifications = () => {
  const { notifications, dropNotification } = useNotificationStore();

  useEffect(() => {
    if (!notifications.length) return;

    const { type, message, title } = notifications.at(0) as Notification;
    if (type == 'success') {
      toast.success(message || title);
    }
    if (type == 'error') {
      toast.error(message || title);
    }
    // clean notification automatically!
    setTimeout(() => dropNotification(), 3000);
  }, [notifications, dropNotification]);
};
